import api from '../api'
import { useMutation } from '@tanstack/react-query'
import { ApiRouteEnum } from '../../enums/ApiRouteEnum'

export const usePostFlexiGroup = (
  successCallBack: (data: any) => void,
  errorCallBack: (data: any) => void,
) => {
  const flexiGroupDetailsEndpoint: string = ApiRouteEnum.FLEXI_NEW
  return useMutation(
    (flexiGroupData: any) => api.post(flexiGroupDetailsEndpoint, flexiGroupData),
    {
      mutationKey: [flexiGroupDetailsEndpoint],
      onSuccess: (data) => {
        successCallBack(data.data)
      },
      onError: (error) => errorCallBack(error),
    },
  )
}
